import {i18nVue} from 'laravel-vue-i18n'
import {configureEcho} from '@laravel/echo-vue'
import {createInertiaApp} from '@inertiajs/vue3'
import '@fortawesome/fontawesome-free/css/all.css'
import {createApp, type DefineComponent, h} from 'vue'
import '@dzangolab/vue-country-flag-icon/dist/CountryFlag.css'

configureEcho({
	broadcaster: 'reverb',
})

const time: number = Date.now()

// On page load or when changing themes, best to add inline in `head` to avoid FOUC
if(localStorage.getItem('theme') === 'dark' || (!('theme' in localStorage) && window.matchMedia('(prefers-color-scheme: dark)').matches)){
	document.documentElement.classList.add('dark')
} else {
	document.documentElement.classList.remove('dark')
}

createInertiaApp({
	resolve: (name: string): DefineComponent => {
		const pages: Record<string, DefineComponent> = import.meta.glob('./Pages/**/*.vue', {
			eager: true,
		})
		return pages[`./Pages/${name}.vue`]
	},
	setup({el, App, props, plugin}): void{
		createApp({render: () => h(App, props)})
		.use(plugin)
		.use(i18nVue, {
			resolve: (lang:string) => {
				const languages:Record<string, any> = import.meta.glob('/resources/lang/*.json', {
					eager: true,
				})
				return languages[`/resources/lang/${lang}.json`].default
			},
		})
		.mount(el)
	},
}).then((): void => {
	console.log(`Loaded app in ${(Date.now() - time) / 1000} seconds!`)
})